import { Row, Col } from 'react-bootstrap';

const PageTitle = ({ children, Buttons }) => (
  <Row className="mb-16">
    <Col>
      <h5 className="fw-600 mb-0 text-gradient-warning-white">{children}</h5>
    </Col>
    <Col className="text-end">
      {Buttons}
    </Col>
  </Row>
);

export default PageTitle;
